import { render, staticRenderFns } from "./OffDays.vue?vue&type=template&id=73632a2b&"
import script from "./OffDays.vue?vue&type=script&lang=js&"
export * from "./OffDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports